/*
 * @Author: 陈祖康
 * @Date: 2021-03-26 15:03:03
 * @LastEditors: 陈祖康
 * @LastEditTime: 2021-03-26 15:06:13
 * @Description: 
 * @Props:  
 * @Emit: 
 */
export function mixin<T, U>(to: any, from: Array<any>): T {
  from.forEach(obj => {
    Object.getOwnPropertyNames(obj).forEach(key => {
      to[key] = obj[key];
    });
  });
  return to;
}